var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.winner_image)?_c('div',[_c('dialog',{staticStyle:{"margin-top":"370px"},attrs:{"open":""}},[_c('h3',[_vm._v(_vm._s(_vm.full_name)+" you win $"+_vm._s(_vm.win_dollar))]),_vm._v(" We will contact you to arrange the details. ")]),_c('img',{attrs:{"src":_vm.winner_image,"alt":"wheel","width":"100%"}})]):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }